// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation,
.app-content {
  /** Distance of the app navigation toggle and the first navigation item to the top edge of the app content container */
  --app-navigation-padding: calc(var(--default-grid-baseline, 4px) * 2);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-17327101] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation[data-v-17327101] {
  --color-text-maxcontrast: var(--color-text-maxcontrast-background-blur, var(--color-text-maxcontrast-default));
  transition: transform var(--animation-quick), margin var(--animation-quick);
  width: 300px;
  --app-navigation-max-width: calc(100vw - (var(--app-navigation-padding) + var(--default-clickable-area) + var(--default-grid-baseline)));
  max-width: var(--app-navigation-max-width);
  position: relative;
  top: 0;
  inset-inline-start: 0;
  padding: 0px;
  z-index: 1800;
  height: 100%;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: var(--color-main-background-blur, var(--color-main-background));
  -webkit-backdrop-filter: var(--filter-background-blur, none);
  backdrop-filter: var(--filter-background-blur, none);
}
.app-navigation--close[data-v-17327101] {
  margin-inline-start: calc(-1 * min(300px, var(--app-navigation-max-width)));
}
.app-navigation__search[data-v-17327101] {
  width: 100%;
}
.app-navigation__body[data-v-17327101] {
  overflow-y: scroll;
}
.app-navigation__content > ul[data-v-17327101] {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--default-grid-baseline, 4px);
  padding: var(--app-navigation-padding);
}
.app-navigation .app-navigation__list[data-v-17327101] {
  height: 100%;
}
.app-navigation__body--no-list[data-v-17327101] {
  flex: 1 1 auto;
  overflow: auto;
  height: 100%;
}
.app-navigation__content[data-v-17327101] {
  height: 100%;
  display: flex;
  flex-direction: column;
}
[data-themes*=highcontrast] .app-navigation[data-v-17327101] {
  border-inline-end: 1px solid var(--color-border);
}
@media only screen and (max-width: 1024px) {
.app-navigation[data-v-17327101] {
    position: absolute;
    border-inline-end: 1px solid var(--color-border);
}
}
@media only screen and (max-width: 512px) {
.app-navigation[data-v-17327101] {
    z-index: 1400;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigation-R4E_wTZ-.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,sHAAsH;EACtH,qEAAqE;AACvE,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8GAA8G;EAC9G,2EAA2E;EAC3E,YAAY;EACZ,wIAAwI;EACxI,0CAA0C;EAC1C,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,iFAAiF;EACjF,4DAA4D;EAC5D,oDAAoD;AACtD;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gDAAgD;AAClD;AACA;AACA;IACI,kBAAkB;IAClB,gDAAgD;AACpD;AACA;AACA;AACA;IACI,aAAa;AACjB;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation,\n.app-content {\n  /** Distance of the app navigation toggle and the first navigation item to the top edge of the app content container */\n  --app-navigation-padding: calc(var(--default-grid-baseline, 4px) * 2);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-17327101] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation[data-v-17327101] {\n  --color-text-maxcontrast: var(--color-text-maxcontrast-background-blur, var(--color-text-maxcontrast-default));\n  transition: transform var(--animation-quick), margin var(--animation-quick);\n  width: 300px;\n  --app-navigation-max-width: calc(100vw - (var(--app-navigation-padding) + var(--default-clickable-area) + var(--default-grid-baseline)));\n  max-width: var(--app-navigation-max-width);\n  position: relative;\n  top: 0;\n  inset-inline-start: 0;\n  padding: 0px;\n  z-index: 1800;\n  height: 100%;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background-color: var(--color-main-background-blur, var(--color-main-background));\n  -webkit-backdrop-filter: var(--filter-background-blur, none);\n  backdrop-filter: var(--filter-background-blur, none);\n}\n.app-navigation--close[data-v-17327101] {\n  margin-inline-start: calc(-1 * min(300px, var(--app-navigation-max-width)));\n}\n.app-navigation__search[data-v-17327101] {\n  width: 100%;\n}\n.app-navigation__body[data-v-17327101] {\n  overflow-y: scroll;\n}\n.app-navigation__content > ul[data-v-17327101] {\n  position: relative;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: var(--default-grid-baseline, 4px);\n  padding: var(--app-navigation-padding);\n}\n.app-navigation .app-navigation__list[data-v-17327101] {\n  height: 100%;\n}\n.app-navigation__body--no-list[data-v-17327101] {\n  flex: 1 1 auto;\n  overflow: auto;\n  height: 100%;\n}\n.app-navigation__content[data-v-17327101] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n[data-themes*=highcontrast] .app-navigation[data-v-17327101] {\n  border-inline-end: 1px solid var(--color-border);\n}\n@media only screen and (max-width: 1024px) {\n.app-navigation[data-v-17327101] {\n    position: absolute;\n    border-inline-end: 1px solid var(--color-border);\n}\n}\n@media only screen and (max-width: 512px) {\n.app-navigation[data-v-17327101] {\n    z-index: 1400;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
